export default __webpack_public_path__ + "static/media/BB_43.55416132.png";